import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import React from "react";
import { FormattedMessage } from "react-intl";
import "./StatementExchangeBetsContentFooter.scss";

const StatementExchangeBetsContentFooter: React.FC<{
  backSubtotal: number;
  laySubtotal: number;
  commissionAmount: number;
  marketSubtotal: number;
  commissionRate: number;
  totalPayout: number;
}> = ({
  backSubtotal,
  laySubtotal,
  commissionAmount,
  marketSubtotal,
  commissionRate,
  totalPayout,
}) => {
  return (
    <div className="statement-exchange__content__footer">
      <div className="statement-exchange__content__footer__row">
        <span className="label">
          <FormattedMessage id="reports-back-subtotal" />
        </span>
        <span className="value">
          <CurrencyNumber value={backSubtotal} />
        </span>
      </div>
      <div className="statement-exchange__content__footer__row">
        <FormattedMessage id="reports-lay-subtotal" />
        <span className="value">
          <CurrencyNumber value={laySubtotal} />
        </span>
      </div>
      <div className="statement-exchange__content__footer__row">
        <span className="label">
          <FormattedMessage id="reports-market-subtotal" />
        </span>
        <span className="value">
          <CurrencyNumber value={marketSubtotal} />
        </span>
      </div>
      <div className="statement-exchange__content__footer__row">
        <span>
          <FormattedMessage id="reports-market-commission" /> @ {commissionRate}
          %
        </span>
        <span className="value">
          <CurrencyNumber value={commissionAmount} />
        </span>
      </div>
      <div className="statement-exchange__content__footer__row">
        <span>
          <FormattedMessage id="reports-net-market-total" />
        </span>
        <span className="value">
          <CurrencyNumber value={totalPayout} />
        </span>
      </div>
    </div>
  );
};

export default StatementExchangeBetsContentFooter;
